<div *ngIf="information"  class="sx-environment__landing-wrapper">
  <div [innerHTML]="information.content | safeHtml" appRouterLink></div>
</div>
<div *ngIf="!information"  class="sx-environment__landing-wrapper">
  <app-no-content [displayText]="('environment.display.empty' | translate)"></app-no-content>
</div>